<template>
<div class="content">

    <div class="form-group ">
        <input type="checkbox" id="save_loop_data" v-model="
                                form.save_loop_data
                            " />
        <label>Save loop data</label>
    </div>

    <div class="form-group ">
        <input type="checkbox" id="save_tracing_data" v-model="
                                form.save_tracing_data
                            " />
        <label>Save tracing data</label>
    </div>

    

</div>
</template>

<script>
export default {
    props: ["form"],
}
</script>